import React, { useEffect, useRef } from "react";
import { Row, Col, Container } from "react-bootstrap";

import SectionHeader from "../components/SectionHeader";
import { getintouchCompData } from "../data/components-getintouch.data";
import { trackEvent } from "../plausible";
import { VectorBackground } from "../components/VectorBackground";

const HS_SCRIPT_SRC = "https://js-eu1.hsforms.net/forms/embed/developer/25477516.js";

const GetInTouch = ({
    hideHeader,
    pageTitle,
    transparentBackground,
    borderedForm,
}) => {
    const compData = getintouchCompData();

    const { label, header } =
        compData.wp.mdaThemeOptions.themeSettings.getintouch;

    const formWrapperRef = useRef(null);

    useEffect(() => {
        const handleSuccess = () => {
            trackEvent("Contact Form: Submitted", {
                props: {
                    "contact-form-page-title": pageTitle,
                },
            });
        };

        window.addEventListener(
            "hs-form-event:on-submission:success",
            handleSuccess
        );
        return () => {
            window.removeEventListener(
                "hs-form-event:on-submission:success",
                handleSuccess
            );
        };
    }, [pageTitle]);

    useEffect(() => {
        if (!formWrapperRef.current) return;

        // Create the HubSpot form div imperatively after React has mounted,
        // so React never manages its children and won't wipe HubSpot's injected content
        // on subsequent re-renders (e.g. triggered by Gatsby's page-data prefetching).
        const formDiv = document.createElement("div");
        formDiv.className = `hs-form-html get-in-touch__form${
            borderedForm ? " get-in-touch__form--bordered" : ""
        }`;
        formDiv.setAttribute("data-region", "eu1");
        formDiv.setAttribute("data-form-id", "b539121c-22cc-4775-829b-47a632b2fb8a");
        formDiv.setAttribute("data-portal-id", "25477516");
        formWrapperRef.current.appendChild(formDiv);

        if (!document.querySelector(`script[src="${HS_SCRIPT_SRC}"]`)) {
            const script = document.createElement("script");
            script.src = HS_SCRIPT_SRC;
            document.head.appendChild(script);
        }

        return () => {
            if (formDiv.parentNode) formDiv.parentNode.removeChild(formDiv);
        };
    }, [borderedForm]);

    return (
        <Container>
            <VectorBackground gradient strokeOpacity={0.2} />
            <Row className="get-in-touch" id="get-in-touch">
                <Col xs="24" style={{ position: "relative" }}>
                    <Row
                        className={`get-in-touch__content ${
                            transparentBackground
                                ? "get-in-touch__content--transparent"
                                : ""
                        }`}
                    >
                        {!hideHeader && (
                            <Col
                                xl={{ span: 14, offset: 5 }}
                                xs={{ span: 22, offset: 1 }}
                            >
                                <div className="get-in-touch__headline">
                                    <SectionHeader
                                        labelBottom={label}
                                        header={header}
                                        variant="light"
                                    />
                                </div>
                            </Col>
                        )}

                        <Col
                            xl={{
                                span: 14,
                                offset: hideHeader ? 0 : 5,
                            }}
                            xs={{ span: 22, offset: hideHeader ? 0 : 1 }}
                        >
                            <div ref={formWrapperRef} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default GetInTouch;
